export enum Airline {
  FINNAIR = 'AY',
  AMERICAN_AIRLINES = 'AA',
  BRITHIS_AIRWAYS = 'BA',
  CATHAY_PACIFIC = 'CX',
  DRAGONAIR = 'KA',
  IBERIA = 'IB',
  JAPAN_AIRLINES = 'JL',
  LAN_AIRLINES = 'LA',
  MALAYSIAN = 'MH',
  QANTAS = 'QF',
  QATAR_AIRWAYS = 'QR',
  ROYAL_JORDANIAN = 'RJ',
  SRI_LANKAN = 'UL',
  TAM_AIRLINES = 'JJ',
  US_AIRWAYS = 'US',
}
